document.addEventListener("click", (e) => {
  // Check if the click was inside a variant option
  const variant = e.target.closest(".select-option .variant_option");
  if (!variant) return; // not a variant click

  const option = variant.querySelector("label")?.textContent.trim();
  const flockingName = document.getElementsByName("properties[nom]")[0];
  const flockingNumber = document.getElementsByName("properties[numero]")[0];
  const customFlockingElement = document.getElementById("custom_flocking");

  if (flockingName && flockingNumber && customFlockingElement) {
    if (option === "Flocage Personnalisé") {
      customFlockingElement.style.display = "block";
      flockingName.setAttribute("required", true);
      flockingNumber.setAttribute("required", true);
    } else {
      customFlockingElement.style.display = "none";
      flockingName.removeAttribute("required");
      flockingNumber.removeAttribute("required");
    }
  } else {
    console.error("Required elements not found");
  }
});

document.addEventListener("click", (e) => {
  // Check if the click was inside a variant option
  const variant = e.target.closest(".variant-option .selectDropdown .option");
  if (!variant) return; // not a variant click

  const option = variant.textContent.trim();
  const flockingName = document.getElementsByName("properties[nom]")[0];
  const flockingNumber = document.getElementsByName("properties[numero]")[0];
  const customFlockingElement = document.getElementById("custom_flocking");

  if (flockingName && flockingNumber && customFlockingElement) {
    if (option === "Flocage Personnalisé") {
      customFlockingElement.style.display = "block";
      flockingName.setAttribute("required", true);
      flockingNumber.setAttribute("required", true);
    } else {
      customFlockingElement.style.display = "none";
      flockingName.removeAttribute("required");
      flockingNumber.removeAttribute("required");
    }
  } else {
    console.error("Required elements not found");
  }
});
